export default "__VITE_ASSET__lgiRH5sI__"